__turbopack_context__.v({
  "arrowBtn": "STHome-module__OtH8Mq__arrowBtn",
  "bioMaterialsContent": "STHome-module__OtH8Mq__bioMaterialsContent",
  "bioMaterialsImageWrapper": "STHome-module__OtH8Mq__bioMaterialsImageWrapper",
  "biomassInsightHeader": "STHome-module__OtH8Mq__biomassInsightHeader",
  "biomassInsightImageWrapper": "STHome-module__OtH8Mq__biomassInsightImageWrapper",
  "blogCard": "STHome-module__OtH8Mq__blogCard",
  "blogImageWrapper": "STHome-module__OtH8Mq__blogImageWrapper",
  "blogLink": "STHome-module__OtH8Mq__blogLink",
  "blogTag": "STHome-module__OtH8Mq__blogTag",
  "blogsSwiper": "STHome-module__OtH8Mq__blogsSwiper",
  "collapsed": "STHome-module__OtH8Mq__collapsed",
  "fundamentalcard": "STHome-module__OtH8Mq__fundamentalcard",
  "fundamentalcardIcon": "STHome-module__OtH8Mq__fundamentalcardIcon",
  "fundamentalcardsWrapper": "STHome-module__OtH8Mq__fundamentalcardsWrapper",
  "fundamentalsSection": "STHome-module__OtH8Mq__fundamentalsSection",
  "getInTouchBtn": "STHome-module__OtH8Mq__getInTouchBtn",
  "heroContent": "STHome-module__OtH8Mq__heroContent",
  "heroInner": "STHome-module__OtH8Mq__heroInner",
  "heroSection": "STHome-module__OtH8Mq__heroSection",
  "heroTitle": "STHome-module__OtH8Mq__heroTitle",
  "heroTitleRotatingText": "STHome-module__OtH8Mq__heroTitleRotatingText",
  "impactCardBody": "STHome-module__OtH8Mq__impactCardBody",
  "impactContent": "STHome-module__OtH8Mq__impactContent",
  "impactImage": "STHome-module__OtH8Mq__impactImage",
  "impactSlider": "STHome-module__OtH8Mq__impactSlider",
  "letsTalkFormTopRow": "STHome-module__OtH8Mq__letsTalkFormTopRow",
  "letsTalkImageWrapper": "STHome-module__OtH8Mq__letsTalkImageWrapper",
  "letsTalkTitle": "STHome-module__OtH8Mq__letsTalkTitle",
  "logoImg": "STHome-module__OtH8Mq__logoImg",
  "logoMarqueeSection": "STHome-module__OtH8Mq__logoMarqueeSection",
  "marquee": "STHome-module__OtH8Mq__marquee",
  "marquee-reverse": "STHome-module__OtH8Mq__marquee-reverse",
  "marqueeContainer": "STHome-module__OtH8Mq__marqueeContainer",
  "marqueeContent": "STHome-module__OtH8Mq__marqueeContent",
  "marqueeLeft": "STHome-module__OtH8Mq__marqueeLeft",
  "marqueeRight": "STHome-module__OtH8Mq__marqueeRight",
  "notificationContent": "STHome-module__OtH8Mq__notificationContent",
  "notificationIconWrapper": "STHome-module__OtH8Mq__notificationIconWrapper",
  "notificationWrapper": "STHome-module__OtH8Mq__notificationWrapper",
  "videoWrapper": "STHome-module__OtH8Mq__videoWrapper",
});
